import React, { useState } from "react";
import SearchBar from "../../reusebale/searchBar";
import TutorialSection from "./tutorialSection";

const HelpSection = () => {
  const [search, setSearch] = useState("");

  return (
    <div className="h-screen">
      <div className="h-[10vh]">
        <SearchBar
          title="Help & Tutorials"
          desc="All available tutorials are listed here."
          value={search}
          onSearchChange={(e) => {
            setSearch(e.target.value);
          }}
        />
      </div>
      <div className="h-[90vh]">
        <TutorialSection searchTerm={search} />
      </div>
    </div>
  );
};

export default HelpSection;
